import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	retryActionContent: {
		id: 'backlog.flags.bulk-actions.error.retry-action-content',
		defaultMessage: 'Try again',
		description: 'Action button that allows a user to retry their failed bulk update of issues',
	},
	viewSummaryActionContent: {
		id: 'backlog.flags.bulk-actions.error.view-summary-action-content',
		defaultMessage: 'View summary',
		description:
			'Action button that allows a user to view the summary of issues that failed to bulk update',
	},
	selectFailedActionContent: {
		id: 'backlog.flags.bulk-actions.error.select-failed-action-content',
		defaultMessage: 'Select failed items',
		description:
			'Action button that allows a user to select/check the failed issues when bulk updating issues',
	},
	learnMoreActionContent: {
		id: 'backlog.flags.bulk-actions.error.learn-more-action-content',
		defaultMessage: 'Learn more',
		description:
			'Action button that allows a user to open the in product help panel with more information about why the error occurred when bulk updating issues',
	},
	flagTitleError: {
		id: 'backlog.flags.bulk-actions.error.flag-title-error',
		defaultMessage: 'Failed to update',
		description: 'Title of the error flag when all bulk updates have failed',
	},
	flagTitlePartialError: {
		id: 'backlog.flags.bulk-actions.error.flag-title-partial-error',
		defaultMessage:
			'{failedCount}/{totalCount} {totalCount, plural, one {items} other {items}} not updated',
		description: 'Title of the error flag when only some bulk updates have failed',
	},
	flagDescriptionError: {
		id: 'backlog.flags.bulk-actions.error.flag-description-error',
		defaultMessage:
			'We were unable to update some of the items. Try again, or view the items that failed to update.',
		description: 'Description of the error flag when all bulk updates have failed',
	},
	flagDescriptionErrorTryLater: {
		id: 'backlog.flags.bulk-actions.error.flag-description-error-try-later',
		defaultMessage:
			'You can view the items that failed to update in a new tab, or wait a few minutes and try again.',
		description:
			'Description of the error flag when the user has retried twice with the same result when bulk updating issues',
	},
	flagDescriptionNetworkError: {
		id: 'backlog.flags.bulk-actions.error.flag-description-network-error',
		defaultMessage:
			'There might be something wrong with the connection. Wait a few minutes, then try again.',
		description:
			'Description of the error flag when the user may have a network error when bulk updating issues',
	},
	flagDescriptionValidationError: {
		id: 'backlog.flags.bulk-actions.error.flag-description-validation-error',
		defaultMessage:
			'The items might not be editable, or you may require permissions. Select the failed items to try again, or view a summary of the failed items.',
		description:
			'Description of the error flag when there is some user validation error such as un-editable fields or missing permissions when the user is bulk updating issues',
	},
});
